export const FETCH_ANNOUNCEMENTS = 'announcements/FETCH_ANNOUNCEMENTS'
export const CLEAR_ANNOUNCEMENTS = 'announcements/CLEAR_ANNOUNCEMENTS'
export const SET_ANNOUNCEMENTS = 'announcements/SET_ANNOUNCEMENTS'
export const DISMISS_ALL_ANNOUNCEMENTS = 'announcements/DISMISS_ALL_ANNOUNCEMENTS'
export const DISMISS_ANNOUNCEMENT = 'announcements/DISMISS_ANNOUNCEMENT'
export const TOGGLE_SHOW_ANNOUNCEMENTS = 'announcements/TOGGLE_SHOW_ANNOUNCEMENTS'
export const SET_SHOW_ANNOUNCEMENTS = 'announcements/SET_SHOW_ANNOUNCEMENTS'
